(function () {
  if (window.__awGalleryFixInstalled) return;
  window.__awGalleryFixInstalled = true;

  function hydrateThumb(image) {
    if (!image || image.dataset.thumbLoaded === 'true') return;
    image.dataset.thumbLoaded = 'true';

    if (image.dataset.thumbSrcset) {
      image.srcset = image.dataset.thumbSrcset;
    }

    if (image.dataset.thumbSrc) {
      image.src = image.dataset.thumbSrc;
    }
  }

  function moveModalsToBody() {
    document.querySelectorAll('[data-gallery-modal]').forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function loadGalleryThumbsIn(container) {
    if (!container) return;

    container.querySelectorAll('[data-gallery-lazy-thumb]').forEach(function (image) {
      if (image.closest('[hidden]')) return;
      hydrateThumb(image);
    });
  }

  function loadVisibleGalleryThumbs() {
    moveModalsToBody();

    document.querySelectorAll('[data-gallery-lazy-thumb]').forEach(function (image) {
      var thumb = image.closest('[data-gallery-thumb], [data-modal-thumb]');
      var modal = image.closest('[data-gallery-modal]');

      if (thumb && thumb.hidden) return;
      if (modal && !modal.classList.contains('is-open')) return;

      hydrateThumb(image);
    });
  }

  function queueVisibleThumbLoad() {
    window.requestAnimationFrame(function () {
      loadVisibleGalleryThumbs();
      window.setTimeout(loadVisibleGalleryThumbs, 120);
    });
  }

  function bindZoomButtons(root) {
    (root || document).querySelectorAll('[data-gallery-zoom]').forEach(function (button) {
      if (button.dataset.galleryFixBound === 'true') return;
      button.dataset.galleryFixBound = 'true';

      button.addEventListener('click', function () {
        window.setTimeout(function () {
          moveModalsToBody();
          document.querySelectorAll('[data-gallery-modal].is-open').forEach(loadGalleryThumbsIn);
        }, 0);
      });
    });
  }

  function getMainImageZoomSrc(mainImage) {
    var gallery = mainImage && mainImage.closest('[data-gallery]');
    var activeThumb = gallery && gallery.querySelector('[data-gallery-thumb].is-active');
    var src = activeThumb && (activeThumb.dataset.zoomSrc || activeThumb.dataset.imageSrc);

    if (!src && mainImage) {
      src = mainImage.currentSrc || mainImage.src || mainImage.getAttribute('src') || '';
      src = src.replace(/([?&])width=\d+/, '$1width=1600');
    }

    return {
      src: src,
      alt: (activeThumb && activeThumb.dataset.imageAlt) || (mainImage && mainImage.alt) || ''
    };
  }

  function openGalleryModal(mainImage) {
    moveModalsToBody();

    var modal = document.querySelector('[data-gallery-modal]');
    var modalImage = modal && modal.querySelector('[data-modal-image]');
    var zoom = getMainImageZoomSrc(mainImage);

    if (!modal || !modalImage || !zoom.src) return;

    modalImage.src = zoom.src;
    modalImage.alt = zoom.alt;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gallery-modal-open');
    document.body.classList.add('gallery-modal-open');
    loadGalleryThumbsIn(modal);
  }

  function closeGalleryModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gallery-modal-open');
    document.body.classList.remove('gallery-modal-open');
  }

  function initGalleryFix() {
    moveModalsToBody();
    bindZoomButtons(document);
    loadVisibleGalleryThumbs();

    if ('MutationObserver' in window && !window.__awGalleryFixObserver) {
      window.__awGalleryFixObserver = new MutationObserver(function (mutations) {
        var shouldQueue = false;

        mutations.forEach(function (mutation) {
          if (mutation.type !== 'childList') return;
          shouldQueue = true;

          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              bindZoomButtons(node);
            }
          });
        });

        if (shouldQueue) queueVisibleThumbLoad();
      });

      window.__awGalleryFixObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  document.addEventListener('pointerdown', queueVisibleThumbLoad, { passive: true });
  document.addEventListener('touchstart', queueVisibleThumbLoad, { passive: true });
  document.addEventListener('focusin', queueVisibleThumbLoad);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-option-value-id], [data-color-option], .color-opt, [data-gallery-zoom]')) {
      queueVisibleThumbLoad();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var mainImage = event.target.closest('[data-gallery-main-image]');
    var zoomButton = event.target.closest('[data-gallery-zoom]');
    var closeButton = event.target.closest('[data-modal-close]');
    var modalThumb = event.target.closest('[data-modal-thumb]');

    if (closeButton) {
      closeGalleryModal(closeButton.closest('[data-gallery-modal]'));
      return;
    }

    if (modalThumb) {
      window.setTimeout(function () {
        loadGalleryThumbsIn(modalThumb.closest('[data-gallery-modal]'));
      }, 0);
      return;
    }

    if (mainImage || zoomButton) {
      window.setTimeout(function () {
        var modal = document.querySelector('[data-gallery-modal]');
        if (!modal || modal.classList.contains('is-open')) {
          if (modal) loadGalleryThumbsIn(modal);
          return;
        }

        openGalleryModal(mainImage || document.querySelector('[data-gallery-main-image]'));
      }, 40);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-gallery-modal].is-open').forEach(closeGalleryModal);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryFix, { once: true });
  } else {
    initGalleryFix();
  }
})();
